import { render } from "./OnlineLayout.vue?vue&type=template&id=c6a3b058&scoped=true"
import script from "./OnlineLayout.vue?vue&type=script&lang=js"
export * from "./OnlineLayout.vue?vue&type=script&lang=js"

import "./OnlineLayout.vue?vue&type=style&index=0&id=c6a3b058&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6a3b058"]])

export default __exports__